import React from 'react'
import { PieAmchartSeeker } from '@ui-seeker/core'
import { Paper, Skeleton } from '@mui/material'
import { userData } from '@signals'
import { isDateRangeLoading } from 'Pages/Main/Home/@signals'
import { useSearchAnalyticsDateRangeInfo } from 'Pages/Main/Home/@hooks'


export default function SearchAnalyticsHomePieChart() {

	const { data } = useSearchAnalyticsDateRangeInfo()
	const { percentageSite, siteSeries } = data

	if (isDateRangeLoading.value)
		return <Skeleton variant="rectangular" sx={{ height: '26vw' }}/>

	if (userData.value?.newUserLogin) {
		return <Paper sx={{ width: "100%", height: 435 }}/>
	}

	return <PieAmchartSeeker
		rootID="SearchAnalyticsPieChart"
		data={percentageSite}
		title="Percentage of searches per site"
		series={[{
			yField: 'site',
			xField: "percentage",
			innerRadius: 60,
		}]}
		sx={{ height: '21vw' }}
		chartProps={{
			chart: {
				horizontalLayout: true,
			},
			root: {
				colors: siteSeries?.map(({ color }) => color)
			},
			legend: {
				centerY: 47.3,
				y: 45,
				verticalLayout: true,
				labels: {
					maxWidth: 140,
					width: 140,
					oversizedBehavior: "wrap"
				},
				valueLabels: {
					textAlign: "right"
				}
			},
			enabledPDF: false
		}}

	/>
}